import React from "react";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { Column, Row } from "@amzn/meridian";
import Headers from "@/features/yard360/Headers";
import { NavigationTabs } from "@/features/yard360/NavigationTabs";
import BuildingCodeSelector from "@/features/yard360/BuildingCodeSelector";
import { YARD360_PATHS } from "@/app/app-constants";
import { RootState } from "@/store";

const selectActiveBuildingCode = (state: RootState) => state.authInfo.activeBuildingCode;

export const Yard360Layout: React.FC = () => {
  const activeBuildingCode = useSelector(selectActiveBuildingCode);

  if (!activeBuildingCode) {
    return null;
  }

  return (
    <Column spacing="500" spacingInset="500" data-testid="yard360LayoutContainer">
      <Headers />
      <Row>
        <NavigationTabs tabs={YARD360_PATHS} />
        <Row>
          <BuildingCodeSelector />
        </Row>
      </Row>
      <Outlet />
    </Column>
  );
};
